export const getChange = (onChange, isMulti) => option => {
  if (!isMulti) {
    return onChange(option ? option.value : null)
  }
  const isObject = item => typeof item === 'object'
  return onChange(option
    .filter(item => isObject(item) ? item.value !== undefined : item !== 'all')
    .map(item => isObject(item) ? item.value : item))
}

export const getValue = (value, isMulti) => {
  if (value === undefined) {
    return isMulti ? [{ label: "all", value: undefined }] : { label: "all", value: undefined }
  } else {
    return value
  }
}

const MULTI_VALUE_SEPARATOR = ':'

export const encodeMultiValue = value => `${typeof value}${MULTI_VALUE_SEPARATOR}${value}`

export const decodeMultiValue = encoded => {
  const separatorIndex = encoded.indexOf(MULTI_VALUE_SEPARATOR)
  const type = encoded.slice(0, separatorIndex)
  const raw = encoded.slice(separatorIndex + 1)

  if (type === 'number') {
    return Number(raw)
  }

  if (type === 'boolean') {
    return raw === 'true'
  }

  return raw
}
